module.exports = __webpack_public_path__ + "static/media/checked_checkbox.e3142c6d.svg";